const url = process.env.NODE_ENV === "development"
    ? "http://localhost:2229"
    : "https://abby.benjamin-widawski.com"

const api = {
    api: url + "/api",
    videos: url + "/videos",
    photos: url + "/photos",
}

export default api
